import { createContext, useContext, ReactNode } from "react";
import { FeatureFlagKey } from "@/types/featureFlags";
import { useFeatureFlags } from "@/hooks/useFeatureFlag";

interface FeatureFlagsContextValue {
  flags: Record<string, boolean>;
  isEnabled: (key: FeatureFlagKey | string) => boolean;
  loading: boolean;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({
  flags: {},
  isEnabled: () => false,
  loading: false,
});

const GLOBAL_FLAGS = [
  FeatureFlagKey.SUBSCRIPTION_PAYWALL,
  FeatureFlagKey.SHOW_PRICING_PAGE,
  FeatureFlagKey.STRIPE_TEST_MODE,
];

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const { flags, loading } = useFeatureFlags(GLOBAL_FLAGS);

  const isEnabled = (key: FeatureFlagKey | string): boolean => {
    return flags[key] || false;
  };

  return (
    <FeatureFlagsContext.Provider value={{ flags, isEnabled, loading }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlagsContext() {
  return useContext(FeatureFlagsContext);
}
